import React from "react";
//Page Components
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import Comment from "../components/Comment.js";
import GlobalStyle from "../components/GlobalStyle";
import Footer from "../components/Footer";
//Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import ScrollTop from "../components/ScrollTop";

const AboutUs = () => {
  return (
    <motion.div
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <AboutSection />
      <ServicesSection />
      <Comment />
      <Footer />
      <ScrollTop />
      <GlobalStyle />
    </motion.div>
  );
};

export default AboutUs;
